import { createTheme } from '@mui/material/styles'

const theme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#D45995',
        },
        secondary: {
            main: '#000000',
        },
    },
    typography: {
        fontFamily: '"DM Sans", "Roboto", "Helvetica", "Arial", sans-serif',
        fontWeightRegular: 600,
    },
})

export default theme
